import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import Alert, { ALERT } from "../../components/shared/Alert"
import ApplicationLayout from "../../layouts/ApplicationLayout"
import { Grid, Header, Image } from "semantic-ui-react"
import OrderStatusWidget from "../../components/dashboard/OrderStatusWidget"
import MaintenanceWidget from "../../components/dashboard/MaintenanceWidget"
import VehiclesWidget from "../../components/dashboard/VehiclesWidget"
import ServiceCostsWidget from "../../components/dashboard/ServiceCostsWidget"
import MileageCostsWidget from "../../components/dashboard/MileageCostsWidget"
import ScheduleServiceButton from "../../components/shared/ScheduleServiceButton"
import { navigationPaths } from "../../constants/paths"
import { withTranslation } from "react-i18next"
import { getSubdomain } from "../../components/shared/StylesheetInjector"
import { isFmcPath } from "../../helpers/pathHelpers"
import { isFMCUser } from "../../helpers/userRoleHelpers"
import { ShimmerThumbnail } from "react-shimmer-effects"
import {
  FMC,
  FMC_FLEET_ADMIN,
  FMC_FLEET_MANAGER,
  REPORTING_ROLES,
  TIRES_RESTRICTED_ROLES
} from "../../constants/roles"
import { DISCOUNT_TIRE, FLEET, FLEETCOR } from "../../constants/application"
import {
  gaJSON,
  logFirebaseAnalyticsScreenName,
  trackFirebaseAnalytics
} from "../../helpers/googleAnalyticsHelpers"
import { getRouteNameFromUrl } from "../../helpers/segmentHelpers"
import { setupSplitFlags } from "../../components/config/SplitClient"
import { isEmpty } from "lodash"
import DownloadAppModal from "./DownloadAppModal"
import { checkSubDomain } from "../../constants/downloadApp"
//import SfoTracking from "../SFyO/SfoTracking"
import { isFleetcor } from "../../helpers/affiliationHelpers"
import { clearStateAfterTimeout } from "../../helpers/documentHelpers"
import UnenrolledVehicles from "../../components/dashboard/UnenrolledVehicles"
import { ValvolineBanner } from "../../components/Banners"
import { NewTiresWidget } from "../../components/dashboard/NewTiresWidget"
import { DTBanner } from "../../components/DtBanner"

class Dashboard extends Component {
  // NOTE: The submission/cancelation logic for "Active Maintenance" approvals in this component is mirrored in /views/dashboard/active_maintenance_index.js (The "View All")

  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isLoadingError: PropTypes.bool.isRequired,
    users: PropTypes.array.isRequired,
    vehicles: PropTypes.array.isRequired
  }

  constructor(props) {
    super(props)

    // NOTE: locationStateData is instantiated as a variable here rather than referencing this.props.location.state.someObj directly because the state key may not be present when navigating to this page from a <Link> that does not explicitly set it.
    const locationStateData = this.props.location.state || {}

    this.state = {
      alert: locationStateData.alert || "",
      alertType: locationStateData.alertType || "default",
      isSubmitting: false
    }

    const params = window.location.href.match(/key=([\w\d-.]+)?&?/)
    const key = (params && params[1]) || locationStateData.key
    const { dispatch, currentUser, t } = this.props

    if (key) {
      dispatch({
        type: "SIGN_OUT_SAGA",
        payload: { currentUser: currentUser },
        callback: this.onSignOutSuccess(key),
        t: t
      })
    }
  }

  onSignOutSuccess = (key) => {
    this.state.isSubmitting = true
    this.onFormSubmit({ key })
  }

  onFormSubmit(formData) {
    const { dispatch } = this.props
    this.setState({ isSubmitting: true })
    dispatch({
      type: "SIGN_IN_SAGA",
      payload: { formData, t: this.props.t, subdomain: getSubdomain() },
      callback: this.afterFormSubmit.bind(this)
    })
  }

  async afterFormSubmit(data) {
    const params =
      this.props.location.state &&
      this.props.location.state.url.match(/error_message=([\w\d-]+)?&?/)
    if (params) {
      window.location.href = this.props.location.state.url
    } else {
      await this.props.dispatch({
        type: "CURRENT_USER_LOAD_SAGA",
        callback: this.onFormSubmitSuccess.bind(this)
      })
    }
  }

  onFormSubmitSuccess(status, data) {
    this.props.dispatch({
      type: "FLEET_LOAD_SAGA",
      payload: { fleetId: this.props.currentUser.fleet_id }
    })
    if ([FMC, FMC_FLEET_ADMIN, FMC_FLEET_MANAGER]?.some((role) => data.roles.includes(role))) {
      if (this.props.isFleetMode) {
        this.props.dispatch({
          type: "FMC_FLIP_SAGA",
          callback: null
        })
      }
      this.props.history.push({ pathname: navigationPaths.fmcDashboard() })
    } else {
      if (!this.props.isFleetMode) {
        this.props.dispatch({
          type: "FMC_FLIP_SAGA",
          callback: null
        })
      }
      this.fetchDashboardData()
      this.props.history.push({ pathname: navigationPaths.dashboard() })
    }
    this.setState({ isSubmitting: false })
  }

  async componentDidMount() {
    await setupSplitFlags.bind(this)({ sub_domain: getSubdomain() })
    logFirebaseAnalyticsScreenName(getRouteNameFromUrl())
    // TODO figure out a better way to do this, for some reason hitting back
    // react-router lets the thing render before set loading event fires in Dashboard saga
    // and explosions happen
    const { isFleetMode } = this.props
    this.loading = true
    if (isFleetMode) this.fetchDashboardData()
    this.loading = false
  }

  afterSubmit(status, data) {
    this.setState({ isSubmitting: false })

    if (status === "success") {
      this.onSubmitSuccess(data)
    } else {
      this.onSubmitFailure(data)
    }
  }

  fetchDashboardData() {
    this.getVehicleData()
    this.getOrderSummary()
    this.getServicesData()
    this.getBasicVehicles()
    this.fetchUnEnrollVehicle()
  }

  getVehicleData() {
    this.props.dispatch({
      type: "LOAD_VEHICLE_STATE_SUMMARY"
    })
  }

  getServicesData() {
    this.props.dispatch({
      type: "SERVICE_REQUEST_ORDERS_AGGREGATE"
    })
  }

  getOrderSummary() {
    this.props.dispatch({
      type: "LOAD_ORDER_SUMMARY"
    })
  }

  getBasicVehicles() {
    this.props.dispatch({
      type: "VEHICLES_BASIC_LOAD_SAGA"
    })
  }

  fetchUnEnrollVehicle() {
    this.props.dispatch({
      type: "LOAD_UN_ENROLL_VEHICLES"
    })
  }

  locationStateData() {
    return this.props.location.state || {}
  }

  onSubmitFailure(data) {
    this.setState({
      alert: data.alert,
      alertType: data.alertType
    })
  }

  onSubmitSuccess(data) {
    this.setState({
      alert: data.alert,
      alertType: data.alertType
    })

    // NOTE: Refreshes "Active Maintenance" data.
    this.fetchDashboardData()
  }

  navigateToVehicle = (vehicle) => {
    this.props.history.push({
      pathname: navigationPaths.vehicleShow(vehicle.id)
    })
  }

  navigateToServicesByMonth = (data) => {
    this.props.history.push({
      pathname: navigationPaths.servicesIndex(),
      state: {
        startingPage: "past",
        startingDate: data.date
      }
    })
  }

  shouldRenderContent() {
    const { isLoading, isLoadingError, vehicles, users, serviceCosts } = this.props

    return (
      !isLoading &&
      !isLoadingError &&
      !this.anyArrayNotPresent([vehicles, users, serviceCosts]) &&
      !this.loading
    )
  }

  anyArrayNotPresent = (arrs) => arrs.filter((arr) => arr === undefined || arr === null).length > 0

  handleAssign = (vehicle) => {
    console.log("Assigning vehicle with card ending in:", vehicle.cardEnding)
  }

  showTires = () => {
    const roles = this.props.currentUser?.roles || []
    const hasAllowedRole = roles.some((role) => !TIRES_RESTRICTED_ROLES.includes(role))
    return getSubdomain() !== DISCOUNT_TIRE && hasAllowedRole && this.state?.showTires === "on"
  }

  renderContent() {
    const {
      vehicles,
      serviceCosts,
      basicVehicles,
      language,
      orderSummary,
      pastDueVehicleIds,
      dueSoonVehicleIds,
      currentUser,
      unEnrollVehicles
    } = this.props

    return (
      <>
        <div className="dashboard mx-auto mt-10 max-w-screen-xl mb-5">
          {/* Top Right-Aligned Button */}
          <div className="flex justify-end items-center">
            <ScheduleServiceButton />
          </div>

          {/* Main Content Area */}
          <div className="grid grid-cols-1 xl:grid-cols-[65%_35%] lg:grid-cols-2 gap-8">
            {/* Left Main Widgets (span 10 columns total, so 10/16 width ~= 62.5%) */}
            <div className="flex flex-col w-full">
              <div className="flex flex-col xl:flex-row w-full gap-8">
                {getSubdomain() === FLEETCOR &&
                  this.props.canUserAccessUnenrollVehicles &&
                  unEnrollVehicles.length > 0 && (
                    <div className="block md:hidden">
                      <UnenrolledVehicles
                        vehicles={unEnrollVehicles}
                        onAssign={this.handleAssign}
                        count={unEnrollVehicles.length}
                      />
                    </div>
                  )}
                <div className="flex-1 min-w-0">
                  {orderSummary ? (
                    <OrderStatusWidget
                      active={orderSummary.active_orders}
                      awaiting={orderSummary.need_approval}
                      approved={orderSummary.approved}
                    />
                  ) : (
                    <ShimmerThumbnail />
                  )}
                </div>
                <div className="flex-1 min-w-0 h-full flex flex-col">
                  <MaintenanceWidget
                    totalVehicle={basicVehicles.length}
                    pastDueVehicleIds={pastDueVehicleIds}
                    dueSoonVehicleIds={dueSoonVehicleIds}
                  />
                </div>
              </div>

              <div className="flex flex-col xl:flex-row w-full gap-8">
                <div className="flex-1 min-w-0">
                  {serviceCosts ? (
                    <ServiceCostsWidget
                      costs={serviceCosts}
                      navigateToServicesByMonth={this.navigateToServicesByMonth}
                      language={language}
                    />
                  ) : (
                    <ShimmerThumbnail />
                  )}
                </div>
                {getSubdomain() !== DISCOUNT_TIRE && this.state?.showTires === "on" && (
                  <div className="flex-1 min-w-0 flex flex-col">
                    {!this.showTires() ? (
                      <NewTiresWidget
                        icon={<img src="/images/tires.svg" className="h-18" />}
                        title="Need New Tires? Let Your Admin Know!"
                        description="Admins can browse and compare tire pricing and schedule installation - all in one place. Let your admin know if you'd like new tires for your vehicle."
                        iconSize="size-24"
                        titleSize="!text-lg !font-semibold"
                      />
                    ) : (
                      <NewTiresWidget
                        icon={<img src="/images/tires.svg" className="h-18" />}
                        title="Shop New Tires"
                        description="Shop for tires by vehicle, compare pricing, and schedule installation - all in one place. Tires ship to your shop of choice before the appointment."
                        linkText="Shop and schedule >"
                        linkClick={() => {
                          trackFirebaseAnalytics({
                            event: gaJSON.tires_entry_clicked,
                            params: {
                              entry_point: "dashboard",
                              user_role: currentUser.roles.toString()
                            }
                          })
                          this.props.history.push({
                            pathname: navigationPaths.tiresSelectVehicle()
                          })
                        }}
                        iconSize="size-24"
                      />
                    )}
                  </div>
                )}
                {(getSubdomain() === DISCOUNT_TIRE || this.state?.showTires === "off") && (
                  <div className="flex-1 min-w-0 flex flex-col">
                    {basicVehicles ? (
                      <MileageCostsWidget
                        vehicles={basicVehicles}
                        navigateTo={this.navigateToVehicle}
                        language={language}
                      />
                    ) : (
                      <ShimmerThumbnail />
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Right Sidebar */}
            <div className="w-full">
              {vehicles ? (
                <>
                  {getSubdomain() === FLEETCOR &&
                    this.props.canUserAccessUnenrollVehicles &&
                    unEnrollVehicles.length > 0 && (
                      <div className="hidden md:block">
                        <UnenrolledVehicles
                          vehicles={unEnrollVehicles}
                          onAssign={this.handleAssign}
                          count={unEnrollVehicles.length}
                        />
                      </div>
                    )}
                  <div>
                    <VehiclesWidget
                      vehicles={vehicles.length > 3 ? vehicles.slice(0, 3) : vehicles}
                      pastDueVehicleIds={pastDueVehicleIds}
                      dueSoonVehicleIds={dueSoonVehicleIds}
                      show_telematics={this.state?.axleFleetTelematicsFlag === getSubdomain()}
                    />
                  </div>
                </>
              ) : (
                <ShimmerThumbnail />
              )}
            </div>
          </div>
        </div>
      </>
    )
  }

  render() {
    const { alert, alertType, showTirePromotionBannerFlag, showTirePromotionBannerConfig } =
      this.state
    const { found } = checkSubDomain()
    return (
      <ApplicationLayout>
        {alert && (
          <Alert
            message={alert}
            type={alertType}
            clearStateAfterTimeout={() => clearStateAfterTimeout(this.setState.bind(this), ALERT)}
          />
        )}
        {!isEmpty(showTirePromotionBannerConfig) &&
          showTirePromotionBannerFlag == getSubdomain() &&
          showTirePromotionBannerConfig.hasOwnProperty("dashboard_banner") && (
            <div>
              <Image
                src={showTirePromotionBannerConfig.dashboard_banner}
                size={20}
                className="margin-bottom-15"
              />
            </div>
          )}
        {getSubdomain() === DISCOUNT_TIRE && <DTBanner />}
        <ValvolineBanner />

        {this.renderContent()}
        {found && <DownloadAppModal />}
      </ApplicationLayout>
    )
  }
} // class Dashboard

const mapStateToProps = (state) => {
  const user = state.application.userSessionData || (state.users && state.users.currentUser)
  const language = state.users.currentUser ? state.users.currentUser.language : ""
  const isFMC = isFMCUser(user)
  const isPathFMC = isFmcPath()

  const canUserAccess = REPORTING_ROLES.some((role) =>
    user?.roles?.some((userRole) => userRole.toLowerCase() === role.toLowerCase())
  )

  return {
    isLoading: state.application.isLoading,
    isLoadingError: state.application.isLoadingError,
    users: state.users.users,
    vehicles: state.vehicles.dashboardVehicles,
    serviceCosts: state.services.serviceCosts,
    maintenanceIntervals: state.maintenanceIntervals,
    language: language,
    isFleetMode: state.application.mode === FLEET || state.application.mode === undefined,
    orderSummary: state.fleets.order_summary,
    pastDueVehicleIds: state.vehicles.pastDueVehicleIds,
    dueSoonVehicleIds: state.vehicles.dueSoonVehicleIds,
    basicVehicles: state.vehicles.basicVehicles,
    unEnrollVehicles: state.vehicles.unEnrollVehicles,
    currentUser: user,
    canUserAccessUnenrollVehicles: canUserAccess
  }
}

export default connect(mapStateToProps)(withTranslation("common")(Dashboard))
